// MST
import { types, flow } from 'mobx-state-tree'

// i18n
import i18n from 'i18next'

const LocalizationStoreModel = types
  .model('Localization')
  .props({
    localization_lang: types.optional(types.string, 'id'),
  })
  .actions(self => ({
    LOCALIZATION_SET_LANGUAGE: (payload: string): void => {
      self.localization_lang = payload
    },
  }))
  .actions(self => ({
    localization_setLanguage: flow(function* (payload: string) {
      yield i18n.changeLanguage(payload)

      self.LOCALIZATION_SET_LANGUAGE(payload)
    }),
  }))

export const createLocalizationStoreDefaultModel = () => types.optional(LocalizationStoreModel, {})
